<template>
	<div class = "login">
		<section class="aui-flexView">
			<section class="aui-scrollView">
				<div class="aui-jop-chang">
					<p style="font-size: 26px;">L&W-Finance</p>
				</div>
				<div class="aui-jop-top">
					<div class="aui-jop-top-box">

						<div class="aui-flex b-line">
							<van-icon name="contact" color="#e54e31" size="2rem"  style="margin-right: 10px;"/>
							<div class="aui-flex-box">
								<van-field v-model="formModel.userCode" placeholder="请输入用户名" />
							</div>
						</div>
						<div class="aui-flex b-line">
							<van-icon name="bag-o" color="#e54e31" size="2rem"  style="margin-right: 10px;"/>
							<div class="aui-flex-box">
								<van-field v-model="formModel.pwd" placeholder="请输入密码" type="password"/>
							</div>
						</div>
						<van-cell-group>
							<van-button style="margin-top: 20px;" type="primary"
										block round color="#fe7844"
										:loading="isLoading"
										@click="checkUser"
										loading-text="登录中...">登录</van-button>
						</van-cell-group>

					</div>
				</div>

			</section>
			<footer class="aui-footer-link">
        <a>Powered By AnswerLYL&WJW</a>
        <a href="https://beian.miit.gov.cn/" target="_blank">蒙ICP备20000755号-1</a>
        <span>

          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=15010502002098" rel="noreferrer" target="_blank"><img  src="/batb.png" width="16" height="17" style="display: inline-block;">蒙公网安备15010502002098</a>
        </span>
			</footer>
		</section>

	</div>
</template>

<script>
	import * as MyApi from '../api/URLApiAddr.js'
	import store from '@/store'
	import * as types from '@/common/types/mutation.js'
  import App from "@/App.vue";


	export default {
		name: 'Login',
    components: {App},
		data() {
			return {
				formModel:{
					userCode: '',
					pwd: '',
				},
				isLoading: false,
				token: ''

			}
		},
		created() {
			this.token = this.$route.query.token;
			this.checkToken();
		},
		methods: {
			checkUser() {
				debugger
				let checkUserCode = this.formModel.userCode;
				let checkPwd =this.formModel.pwd;

				if(checkUserCode == undefined  || checkUserCode == '' || checkUserCode == null){
					this.$toast.fail("用户名不能为空")
					return false
				}
				if(checkPwd == undefined || checkPwd == null || checkPwd == ''){
					this.$toast.fail("密码不能为空")
					return false
				}

				//let thiz = this
				this.isLoading = true
				let params = this.formModel

				let loginUrl = MyApi.LOGIN_URL;
				this.$axios.post(MyApi.LOGIN_URL,params/*,options*/)
						.then((data) => {
							//let data = response.data;
							debugger
							//this.formModel.amount = ''
							//thiz.$toast.success(data.msg);
							this.isLoading = false
							store.commit(types.SYS+types.LOGIN)
							store.commit(types.SYS + types.PUT_USER,data.data);
							//获取token，通知快应用
							try{
								let token = store.state.sys.token;
								let msg = {"token":token,"type":"ADD","userCode":checkUserCode}
								//通知快应用写法,正常用浏览器访问会报错,所以进行异常处理
								window.system.postMessage(JSON.stringify(msg));
							}catch (e) {
								console.log("err", e);
							}
							if(this.$route.query.redirect){
								this.$router.push(this.$route.query.redirect)
							}else{
								this.$router.push({path:"/"})
							}
							//this.$router.push({path:"/"})

							this.isLoading = false
						})
						.catch((err) => {
							console.log("err", err);
							debugger
							this.$toast.fail("请求异常,请稍后再试!!!");
							this.isLoading = false
						})
			},
			checkToken(){
				debugger;
				if(this.token && this.token != ''){
					let params = {"token": this.token}
					this.$axios.post(MyApi.CHECK_TOKEN_URL,params/*,options*/)
					.then((data) => {
						//let data = response.data;
						debugger
						//this.formModel.amount = ''
						//thiz.$toast.success(data.msg);
						this.isLoading = false
						store.commit(types.SYS+types.LOGIN)
						store.commit(types.SYS + types.PUT_USER,data.data);
						//获取token，通知快应用,验证token不需要通知快应用
						let token = store.state.sys.token;
						let user = store.state.sys.user;
						let msg = {"token":token,"userCode":user.userCode}
						try{
							//通知快应用写法,正常用浏览器访问会报错,所以进行异常处理
							window.system.postMessage(JSON.stringify(msg));
						}catch (e) {
							console.log("err", e);
						}

						if(this.$route.query.redirect){
							this.$router.push(this.$route.query.redirect)
						}else{
							this.$router.push({path:"/"})
						}
						//this.$router.push({path:"/"})

						this.isLoading = false
					})
					.catch((err) => {
						alert(err);
						console.log("err", err);
						debugger
						this.$toast.fail("请求异常,请稍后再试!!!");
						this.isLoading = false
					})
				}
			}

		}
	}
</script>

<style scoped="scoped">

	.login {
		color: #333;
		margin: 0;
		height: 100%;
		font-family: "Myriad Set Pro","Helvetica Neue",Helvetica,Arial,Verdana,sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-weight: normal;
		background: #e6e6e6;
	}

	html,body {
		color: #333;
		margin: 0;
		height: 100%;
		font-family: "Myriad Set Pro","Helvetica Neue",Helvetica,Arial,Verdana,sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-weight: normal;
	}

	* {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
	}

	a {
		text-decoration: none;
		color: #000;
	}

	a, label, button, input, select {
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}

	img {
		border: 0;
	}

	body {
		background: #e6e6e6;
		color: #666;
	}

	html, body, div, dl, dt, dd, ol, ul, li, h1, h2, h3, h4, h5, h6, p, blockquote, pre, button, fieldset, form, input, legend, textarea, th, td {
		margin: 0;
		padding: 0;
	}

	a {
		text-decoration: none;
		color: #08acee;
	}

	button {
		outline: 0;
	}

	img {
		border: 0;
	}

	button,input,optgroup,select,textarea {
		margin: 0;
		font: inherit;
		color: inherit;
		outline: none;
	}

	li {
		list-style: none;
	}

	a {
		color: #666;
	}

	.clearfix::after {
		clear: both;
		content: ".";
		display: block;
		height: 0;
		visibility: hidden;
	}

	.clearfix {
	}


	.divHeight {
		width: 100%;
		height: 10px;
		background: #f5f5f5;
		position: relative;
		overflow: hidden;
	}

	.r-line {
		position: relative;
	}

	.r-line:after {
		content: '';
		position: absolute;
		z-index: 0;
		top: 0;
		right: 0;
		height: 100%;
		border-right: 1px solid #D9D9D9;
		-webkit-transform: scaleX(0.5);
		transform: scaleX(0.5);
		-webkit-transform-origin: 100% 0;
		transform-origin: 100% 0;
	}

	.b-line {
		position: relative;
	}

	.b-line:after {
		content: '';
		position: absolute;
		z-index: 2;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 1px;
		border-bottom: 1px solid #e2e2e2;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
		-webkit-transform-origin: 0 100%;
		transform-origin: 0 100%;
	}

	.aui-flex {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		padding: 15px;
		position: relative;
	}

	.aui-flex-box {
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		min-width: 0;
		font-size: 14px;
		color: #333;
	}


	/* 必要布局样式css */

	.aui-flexView {
		width: 100%;
		height: 100%;
		margin: 0 auto;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		-ms-flex-direction: column;
		flex-direction: column;
	}

	.aui-scrollView {
		width: 100%;
		height: 100%;
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		-ms-flex: 1;
		flex: 1;
		overflow-y: auto;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		position: relative;
	}

	.aui-navBar {
		height: 44px;
		position: relative;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		z-index: 1002;
		background: #f6f6f6;
	}


	.aui-navBar-item {
		height: 44px;
		min-width: 25%;
		-webkit-box-flex: 0;
		-webkit-flex: 0 0 25%;
		-ms-flex: 0 0 25%;
		flex: 0 0 25%;
		padding: 0 0.9rem;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
		font-size: 0.7rem;
		white-space: nowrap;
		overflow: hidden;
		color: #808080;
		position: relative;
	}

	.aui-navBar-item:first-child {
		-webkit-box-ordinal-group: 2;
		-webkit-order: 1;
		-ms-flex-order: 1;
		order: 1;
		margin-right: -25%;
		font-size: 0.9rem;
		font-weight: bold;
	}

	.aui-navBar-item:last-child {
		-webkit-box-ordinal-group: 4;
		-webkit-order: 3;
		-ms-flex-order: 3;
		order: 3;
		-webkit-box-pack: end;
		-webkit-justify-content: flex-end;
		-ms-flex-pack: end;
		justify-content: flex-end;
	}

	.aui-center {
		-webkit-box-ordinal-group: 3;
		-webkit-order: 2;
		-ms-flex-order: 2;
		order: 2;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
		height: 44px;
		width: 50%;
		margin-left: 25%;
	}

	.aui-center-title {
		text-align: center;
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		display: block;
		text-overflow: ellipsis;
		font-size: 0.95rem;
		color: #333;
	}

	.icon {
		width: 20px;
		height: 20px;
		display: block;
		border: none;
		float: left;
		background-size: 20px;
		background-repeat: no-repeat;
	}

	.aui-jop-chang{
		width:100%;
		padding:3.5rem 0;
		text-align:center;
		background-image: -webkit-gradient(linear,left top,right top,from(#e54e31),to(#fe7844));
		background-image: -webkit-linear-gradient(left,#e54e31,#fe7844);
		background-image: -moz-linear-gradient(left,#e54e31,#fe7844);
		background-image: linear-gradient(to right,#e54e31,#fe7844);
		background-color: #fe7844;
		height:200px;
		color:#fff;
		font-size:0.95rem;
	}


	.aui-jop-top{
		margin-top:-90px;
		padding:10px;
	}

	.aui-jop-top-box{
		width:100%;
		padding:4rem 1rem;
		border-radius:3px;
		background:#fff;
	}


	.aui-form-item{
		width:25px;
		height:25px;
	}


	.aui-form-item img{
		width:25px;
		height:25px;
		display:block;
		border:none;
	}


	.aui-flex-box input{
		width:100%;
		height:auto;
		padding:0.3rem 0;
		color:#e54e31;
		background:none;
		border:none;
	}


	.aui-psd a{
		color:#646464;
		font-size:0.85rem;
	}


	.aui-form-button{
		padding:2rem 0;
	}

	.aui-form-button button{
		background:#de442c;
		width:90%;
		margin:0 auto;
		display:block;
		padding:0.5rem 0;
		border-radius:20px;
		border:none;
		color:#fff;
	}


	.aui-register a{
		text-align:center;
		color:#6a6a6a;
		display:block;
		padding:1.5rem 0;
		font-size:0.9rem;
	}

	.aui-register-a a{
		padding:0;
		color:#de442c;
		font-size:0.9rem;
	}

	.aui-footer-link{
		text-align:center;
	}

	.aui-footer-link a{
		color:#6a6a6a;
		display:block;
		padding:1rem 0;
		font-size:0.9rem;
	}

	.aui-footer-link a em{
		color:#08acee;
		font-style:normal;
	}
</style>
